import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fields",
  "use": "fields-usage",
  "viewBox": "0 0 14 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 12\" id=\"fields\"><path d=\"M9 .5H5v11h4V.5ZM10 11.5h2.25c.69 0 1.25-.56 1.25-1.25v-8.5c0-.69-.56-1.25-1.25-1.25H10v11ZM1.75.5H4v11H1.75c-.69 0-1.25-.56-1.25-1.25v-8.5C.5 1.06 1.06.5 1.75.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol